<template>
    <div v-if="visible" class="hard-copy-prescriptions mt-2 mb-2">
        <div class="header d-flex align-items-center" @click="expanded = !expanded" style="cursor: pointer;">
            <i :class="['fa', expanded ? 'fa-chevron-down' : 'fa-chevron-right', 'mr-1']"></i>
            <strong>{{ prescriptions.length }} prescription{{ prescriptions.length !== 1 ? 's' : '' }} on this hard copy</strong>
        </div>
        <div v-if="expanded" class="prescription-list mt-1">
            <div v-for="rx in prescriptions" :key="`${rx.storeID}-${rx.rxNumber}-${rx.rfNumber}`"
                 class="rx-item p-1 pl-2 pr-2"
                 :class="{ 'current-rx': isCurrent(rx) }">
                <template v-if="isCurrent(rx)">
                    <span class="rx-id font-weight-bold">{{ rx.storeID }}-{{ rx.rxNumber }}-{{ rx.rfNumber }}</span>
                    <span class="badge badge-primary ml-1">Current</span>
                    <span class="ml-2 text-muted">{{ rx.patientLastName }}, {{ rx.patientFirstName }}</span>
                    <span v-if="rx.drugName" class="ml-2 text-muted">- {{ rx.drugName }}</span>
                </template>
                <template v-else>
                    <router-link :to="linkTo(rx)" target="_blank">
                        {{ rx.storeID }}-{{ rx.rxNumber }}-{{ rx.rfNumber }}
                    </router-link>
                    <span class="ml-2">{{ rx.patientLastName }}, {{ rx.patientFirstName }}</span>
                    <span v-if="rx.drugName" class="ml-2 text-muted">- {{ rx.drugName }}</span>
                </template>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Axios from 'axios';
import { PrescriptionOnHardCopy } from '@/models/PrescriptionOnHardCopy';

@Component({ name: 'HardCopyPrescriptionsComponent' })
export default class HardCopyPrescriptionsComponent extends Vue {
    @Prop() imageID!: number | null;
    @Prop() currentStoreID!: number;
    @Prop() currentRxNumber!: number;
    @Prop() currentRfNumber!: number;

    private prescriptions: PrescriptionOnHardCopy[] = [];
    private expanded = true;

    get visible(): boolean {
        return this.prescriptions.length > 1;
    }

    @Emit('count-changed')
    emitCountChanged(count: number) {
        return count;
    }

    @Watch('imageID', { immediate: true })
    async onImageIdChanged(newVal: number | null): Promise<void> {
        this.prescriptions = [];
        if (!newVal) {
            this.emitCountChanged(0);
            return;
        }
        try {
            const response = await Axios.get<PrescriptionOnHardCopy[]>(`/Prescription/by-image/${newVal}`);
            this.prescriptions = response.data;
            this.expanded = this.prescriptions.length > 1;
        } catch {
            this.prescriptions = [];
        }
        this.emitCountChanged(this.prescriptions.length);
    }

    isCurrent(rx: PrescriptionOnHardCopy): boolean {
        return rx.storeID === this.currentStoreID
            && rx.rxNumber === this.currentRxNumber
            && rx.rfNumber === this.currentRfNumber;
    }

    linkTo(rx: PrescriptionOnHardCopy): object {
        return {
            name: 'PrescriptionDetailsId',
            params: { rxId: `${rx.storeID}-${rx.rxNumber}-${rx.rfNumber}` },
        };
    }
}
</script>

<style scoped>
.hard-copy-prescriptions {
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 6px 10px;
    background: #f8f9fa;
    font-size: 0.875rem;
}

.rx-item {
    border-radius: 3px;
}

.rx-item.current-rx {
    border-left: 3px solid #007bff;
    background: #e7f1ff;
}
</style>
